import styled from "styled-components";

export default styled.div`
  padding: 1rem;
  border-radius: 12px;
  cursor: pointer;

  .user-card-cont {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .user-card-header {
      display: flex;
      align-items: flex-start;
      gap: 1rem;

      .user-card-title {
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        gap: 0.2rem;

        .user-card-uni {
          display: flex;
          align-items: center;
          justift-content: flex-start;
          gap: 0.3rem;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0.75rem;

    .user-card-cont {
      .user-card-header {
        .user-card-title {
          .user-card-uni {
          }
        }
      }
    }
  }
`;
